import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import TextLink from '@/components/TextLink';
import useTerms from '@/hooks/use-terms';
import { onKeyDownHandler } from '@/shared/utils/a11y';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
  readonly isShaking?: boolean;
};

const EvaAgreement = ({ className, isShaking }: Props) => {
  const { t } = useTranslation();
  const { termsAgreement, setTermsAgreement, termsOfUseUrl, privacyPolicyUrl, isTermsDisabled } =
    useTerms();

  const toggle = useCallback(() => {
    setTermsAgreement((value) => !value);
  }, [setTermsAgreement]);

  if (isTermsDisabled) {
    return null;
  }

  return (
    <div
      role="radio"
      aria-checked={termsAgreement}
      tabIndex={0}
      className={classNames(styles.agreement, isShaking && styles.shake, className)}
      onClick={toggle}
      onKeyDown={onKeyDownHandler({
        Escape: () => {
          setTermsAgreement(false);
        },
        Enter: toggle,
        ' ': toggle,
      })}
    >
      <span className={classNames(styles.check, termsAgreement && styles.checked)} />
      <span className={styles.text}>
        {t('eva_domestic.agreement_prefix')}{' '}
        {termsOfUseUrl && (
          <TextLink
            className={styles.link}
            href={termsOfUseUrl}
            target="_blank"
            type="secondary"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            {t('eva_domestic.terms')}
          </TextLink>
        )}
        {termsOfUseUrl && privacyPolicyUrl && t('eva_domestic.agreement_and')}
        {privacyPolicyUrl && (
          <TextLink
            className={styles.link}
            href={privacyPolicyUrl}
            target="_blank"
            type="secondary"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            {t('eva_domestic.privacy')}
          </TextLink>
        )}
      </span>
    </div>
  );
};

export default EvaAgreement;
